import React, { useState, useEffect } from 'react'

function InputComponent({ value, onChange, ...inputProps }) {
  const [state, setstate] = useState('')

  useEffect(() => {
    if (value === undefined) return
    setstate(Mask(value))
  }, [value])

  const onInput = (ev) => {
    var valMasked = Mask(ev.target.value)
    setstate(valMasked)
    if (onChange) {
      onChange({ target: { value: valMasked.replace(/\D/g, ''), ...inputProps } })
    }
  }

  const Mask = (value) => {
    if (value === undefined) return

    if (value.replace(/\D/g, '').length > 10) {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(\d{4})\d+?$/, '$1')
    } else {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(\d{4})\d+?$/, '$1')
    }
  }

  return <input onChange={onInput} type="text" value={state} {...inputProps} />
}

export default InputComponent
